import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogVisibilityDropdownTriggerLabelWireframe from './VeltCommentDialogVisibilityDropdownTriggerLabelWireframe/VeltCommentDialogVisibilityDropdownTriggerLabelWireframe';
import VeltCommentDialogVisibilityDropdownTriggerIconWireframe from './VeltCommentDialogVisibilityDropdownTriggerIconWireframe/VeltCommentDialogVisibilityDropdownTriggerIconWireframe';
;
var VeltCommentDialogVisibilityDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityDropdownTriggerWireframe.Label = VeltCommentDialogVisibilityDropdownTriggerLabelWireframe;
VeltCommentDialogVisibilityDropdownTriggerWireframe.Icon = VeltCommentDialogVisibilityDropdownTriggerIconWireframe;
export default VeltCommentDialogVisibilityDropdownTriggerWireframe;
